<template>
	<div
		class="app-side-nav"
		:class="{'app-side-nav--expanded' : expanded}"
	>
		<AppImage
			v-if="expanded"
			title="upmood logo"
			:src="require('@/assets/img/upmood-brand.svg')"
			class="app-side-nav__brand"
		/>

		<AppImage
			v-else
			title="upmood logo"
			:src="require('@/assets/img/upmood-logo.svg')"
			class="app-side-nav__logo"
		/>

		<div class="app-side-nav__divider"></div>

		<div class="app-side-nav__links">
			<a
				class="link"
				:class="{'link--active' : $route.path.includes(link.name)}"
				v-for="(link, index) of links"
				:key="index"
				@click="$router.push({ name: link.name })"
			>
				<AppIcon
					class="link__icon"
					:icon-name="link.icon"
				/>

				<span class="link__text" v-show="expanded">
					{{ link.text }}
				</span>
			</a>
		</div>

		<div
			class="app-side-nav__toggle"
			@click="expanded = !expanded"
		>
			<AppIcon
				class="icon"
				v-show="expanded"
				icon-name="navigationExpanded"
			/>

			<AppIcon
				class="icon"
				v-show="!expanded"
				icon-name="navigationShrink"
			/>
		</div>

		<!-- <AppDropdown
			class="app-side-nav__language"
			:placeholder="expanded ? 'Language' : ''"
			display-prop="text"
			v-model="language"
			@input="selectLanguage($event)"
			:options="languages"
		>
			<template #selected="{props}">
				<img
					:src="props.option.icon"
					class="icon"
				>

				<span v-show="expanded">
					{{props.option.text}}
				</span>
			</template>
			<template #option="{props}">
				<img
					:src="props.option.icon"
					class="icon"
				>

				<span>
					{{props.option.text}}
				</span>
			</template>
		</AppDropdown> -->
	</div>
</template>

<script>
export default {
	props: {
		links: {
			type: Array,
			required: true
		},

		current: { default: null }
	},

	data () {
		return {
			expanded: true
			// language: '',
			// languages: [
			// 	{ text: 'English', icon: '' },
			// 	{ text: 'Japanese', icon: '' }
			// ]
		}
	}

	// mounted () {
	// 	this.setDefaultLanguage()
	// },

	// methods: {
	// 	selectLanguage (lang) {
	// 		if (!lang) this.setDefaultLanguage()
	// 		this.$emit('change-language', this.languages)
	// 	},

	// 	setDefaultLanguage () {
	// 		this.language = this.languages[0]
	// 	}
	// }
}
</script>

<style lang="scss" scoped>
.app-side-nav {
	box-shadow: 0 0 3px $default-light;
	height: 100%;
	display: flex;
	flex-direction: column;
	font-family: Montserrat, sans-serif;
	z-index: 9;

	&__logo {
		margin: 1.5em auto;
		width: 30px;
		height: 30px;
	}

	&__brand {
		margin: 1.5em auto;
		width: 100%;
		height: 20px;
	}

	&__divider {
		width: 50%;
		margin: 3em auto;
		border-top: 1px solid lighten($default-light, 12%);
	}

	&__links {
		flex: 1 1 auto;
		display: flex;
		flex-direction: column;
		overflow-y: auto;

		.link {
			padding: .8em 2em;
			display: block;
			list-style: none;
			cursor: pointer;
			color: $default;

			&__icon { width: 1.2em; }
			&__text { margin-left: .5em; }

			&:hover, &--active {
				color: $primary;
			}
		}
	}

	&__toggle {
		margin: 30px auto;
		cursor: pointer;
		color: $default;

		&:hover { color: $primary; }

		.icon { width: 1.2em; }
	}

	// &__language {
	// 	margin: 2em auto;

	// 	.icon {
	// 		width: 20px;
	// 		min-height: 1em;
	// 		background-color: #eee;
	// 	}

	// 	::v-deep .app-dropdown {
	// 		&__toggle {
	// 			border: none;
	// 			padding: 0;
	// 		}

	// 		&__arrow {
	// 			display: none;
	// 		}
	// 	}
	// }

	&--expanded &__logo {
		width: 100px;
	}

	&--expanded &__toggle { margin: 30px 2em; }
	// &--expanded &__language { margin: 2em; }

}
</style>
